import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class AdaniUserFilter extends Component {
    state = {
        emailLists:[],
        emailValue:null,
        isEmailLoading: true
    };
    componentDidMount(){
        this._get_adani_users();
    }

    resetEmailFilter(){
        this.setState({
        emailValue: [],
        })
    }
     _get_adani_users(){
        axios.get(config.get('API_URL')+'/filters/get-all-adani-users/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((email, index) => {
                    this.state.emailLists.push({value: email.email, label: email.email})
                });
            }
        });
     }
     changeEmail(optionSelected){
        let value='';
        let emailArray = [];
        if(optionSelected.length < 1){
            value = null;
            emailArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                emailArray.push(mids.value)
                var index = this.state.emailLists.findIndex(obj => obj.value==mids.value);
                this.state.emailLists.move(index,0).join(',');

            });
        }
        this.props.onSelectEmail(optionSelected,emailArray);
        this.setState({
            emailValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="email"
            isMulti
            value={this.state.emailValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeEmail.bind(this)}
            options={this.state.emailLists}
            placeholderButtonLabel="Select [Email]"
        />
        );

    }
}
export default AdaniUserFilter;